export default __webpack_public_path__ + "static/media/badoo_0_lowdef.6eea5df9.png";